import React from 'react';
import "./Slots.css";

export function Slots(props: { children: React.ReactNode; width?: number; }) {
  return <div className="slots">
    {props.children}
  </div>;
}
